<script>
  const storiesToShow = 4;

  let { stories, stillScraping, formatNumber } = $props();

  let viewAllStories = $state(false);

  function toggleStories(e) {
    e.preventDefault();
    viewAllStories = !viewAllStories;
  }
</script>

<div class="bg-white shadow rounded-lg p-6">
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-lg font-medium text-gray-900">Recent Stories</h3>

    {#if stories.length > storiesToShow}
      <a
        onclick={toggleStories}
        href="#"
        class="text-sm font-medium text-indigo-600 hover:text-indigo-800"
        >View {viewAllStories ? "Less" : "More"}</a
      >
    {/if}
  </div>

  {#if stillScraping && stories.length === 0}
    <div
      class="flex flex-col items-center justify-center py-6 bg-gray-50 rounded-lg shadow-sm"
    >
      <svg
        class="w-10 h-10 text-indigo-400 mb-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
        ></path>
      </svg>
      <p class="text-gray-600 font-medium mb-2">Loading recent stories</p>
      <div class="flex space-x-1 mt-1">
        <div
          class="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
          style="animation-delay: 0ms"
        ></div>
        <div
          class="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
          style="animation-delay: 150ms"
        ></div>
        <div
          class="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
          style="animation-delay: 300ms"
        ></div>
      </div>
    </div>
  {/if}

  <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
    {#each stories.slice(0, viewAllStories ? 999 : storiesToShow) as story}
      <div
        class="bg-gray-50 rounded-lg overflow-hidden shadow hover:shadow-md transition-shadow duration-300 flex flex-col"
      >
        <div class="relative">
          <div
            class="aspect-[9/16] bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center"
          >
            {#if story.image_url}
              <img
                src={story.image_url}
                alt="Story Image"
                class="w-full h-full object-cover"
              />
            {:else}
              <div class="flex items-center justify-center h-full w-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-12 w-12 text-white opacity-90"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
            {/if}
          </div>
          {#if story.is_video}
            <div
              class="absolute top-2 right-2 bg-black bg-opacity-60 rounded-full p-1 text-xs text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          {/if}
          {#if story.story_view_count}
            <div
              class="absolute bottom-2 left-2 bg-black bg-opacity-60 rounded-full px-2 py-1 text-xs text-white flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              {formatNumber
                ? formatNumber(story.story_view_count)
                : story.story_view_count}
            </div>
          {/if}
        </div>
        <div class="p-2 flex flex-col flex-grow">
          <div class="flex items-center justify-between text-xs text-gray-500">
            <span class="text-xs"
              >{new Date(story.taken_at_timestamp * 1000).toLocaleDateString(
                "en-US",
                {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                }
              )}</span
            >
          </div>
          {#if story.tappable_objects && story.tappable_objects.length > 0}
            <div class="mt-2 pt-2 border-t border-gray-100">
              <div class="flex flex-wrap gap-1">
                {#each story.tappable_objects as tag}
                  <span
                    class="text-xs bg-indigo-100 text-indigo-800 px-1.5 py-0.5 rounded-full"
                  >
                    @{tag.username}
                  </span>
                {/each}
              </div>
            </div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</div>
